<template>
    <div class="media_reports">
        <p v-if="hasLine" class="homeComTitle hasLine">
            <span class="titleLine"></span>
            <span>{{ title }}</span>
        </p>
        <p v-else class="homeComTitle icon">
            <span>{{ title }}</span>
        </p>

        <div v-if="!slotmag && list.length" class="mag" v-html="content"></div>
        <slot v-else></slot>

        <table v-if="list.length">
            <thead class="thead fs12">
            <tr>
                <td>排名</td>
                <td class="text_l pl15 ml5" style="width: 30%">媒体</td>
                <td><b>{{ tendency === 'negative' ? '敏感' : '' }}</b>报道量</td>
                <td class="ml10">全网<b>{{label}}</b>报道分布</td>
            </tr>
            </thead>
            <tbody class="tbody fs14 font_n">
            <tr v-for="(item, index) in list" :key="index">
                <td class="co_333">{{ index + 1 }}</td>
                <td class="text_l ml5" style="width: 30%"><span class="co_333">{{ item.name }}</span></td>
                <td><span>{{ item.count }}</span></td>
                <td class="ml10" style="width: 24%">
                    <div class="barBox barBoxBg flex_box ">
                        <p :style="{ width: item.percent + '%' }"></p>
                        <p :style="{ width: 100-item.percent + '%' }"></p>
                    </div>
                </td>
                <td><span class="fs12 flex_1 text_c ml5">{{ item.percent }}%</span></td>
            </tr>
            </tbody>
        </table>
        <img v-else class="noDataImg mt28" src="../../assets/img/company/noData.svg" alt="">

        <!--        <div v-show="list.length > 5" class="checkMore text_c co_666" @click="checkMore">查看更多</div>-->
    </div>
</template>

<script>

import common from "../../util/common";

export default {
    components: {},
    props: {
        renderData: Array,
        entityType: String,
        entity: String,
        tendency: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "媒体报道倾向"
        },
        slotmag: {
            type: Boolean,
            default: false
        },
        periodStr: {
            type: String,
            default: "日"
        },
        articleCount: {
            type: Number,
            default: 0
        },
        hasLine: Boolean
    },
    data() {
        return {
            list: [],
            label: '',
            // subLabel: '',
            dateStr: common.formatDateStr(this.periodStr),
            content:`${this.dateStr}，暂无${ this.label }报道！`
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.label = this.tendency  === "negative" ? "敏感" : this.tendency == "positive" ? "正面" : "";
            // this.subLabel = this.tendency  === "negative" ? "报道" : this.tendency == "positive" ? "报道" : "舆情";
            this.list = this.renderData.length ? [...this.renderData].splice(0, 5) : [];

            if(!this.slotmag && this.list.length){
                this.content = `${this.dateStr}，${common.convertEntityNameStr(this.entity, this.entityType)}<b>${this.label}</b>报道的核心发布媒体为<b class="font_b">${ this.list[0].name }</b>，共发布${this.label}报道<b>${this.list[0].count}篇</b>，占${this.dateStr}${common.convertEntityName(this.entity, this.entityType)}${this.label}报道总量的<b class="font_b">${ this.list[0].percent }%</b>，需重点关注。`
            }
        },
        checkMore() {

        }
    },

}
</script>

<style lang="scss" scoped>
.media_reports {
    box-sizing: border-box;
    text-align: left;
    padding: 16px;

    .icon {
        //font-size: 16px;
        //color: #333333;
        //font-weight: bold;
        //text-indent: 20px;
        //background-size: 18px 18px;
        //background-repeat: no-repeat;
        //background-position: left center;
        //background: url("../../assets/img/icon/media.png") no-repeat left;
        background-image: url("../../assets/img/icon/textIcon.png") ;


    }

    .mag {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333333;
        margin-top: 12px;
    }

    table {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 20px;

        tr {
            width: 100%;
            text-align: center;

            td {
                &:nth-of-type(1) {
                    width: 10%;
                }

                &:nth-of-type(2) {
                    width: 20%;
                }

                &:nth-of-type(3) {
                    width: 20%;
                }

                &:nth-of-type(4) {
                    width: 33%;
                    overflow: hidden;
                    align-items: center;
                }
            }
        }

        .thead {
            tr {
                color: #666666;
                display: flex;
                height: 36px;
                line-height: 36px;
            }
        }

        .tbody {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            tr {
                color: #666666;
                display: flex;

                td {
                    height: 36px;
                    line-height: 36px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                    b {
                        width: auto;
                        height: 36px;
                        line-height: 36px;
                        vertical-align: middle;
                    }

                    &:nth-of-type(1) {
                        overflow: hidden;
                    }

                    &:nth-of-type(2) {
                        overflow: hidden;
                    }

                    &:nth-of-type(3) {
                        overflow: hidden;

                    }

                    &:nth-of-type(4) {
                        display: flex;
                        align-list: center;
                    }

                    &:nth-of-type(5) {
                        text-align: center;
                    }
                }
            }
        }

        .barBoxBg {
            background-color: #c3d2f0;
            overflow: hidden;
        }

        .barBox {
            width: 100%;
            height: 16px;
            border-radius: 8px;
            p {
                height: 100%;

                &:nth-child(1) {
                    background-color: #386ccf;
                }

                &:nth-child(2) {
                    background-color: #FFFFFF;
                    border-radius: 0 8px 8px 0;
                    border-top: 1PX solid hsl(0deg 5% 86%);
                    border-bottom: 1PX solid hsl(0deg 5% 86%);
                    border-right: 1PX solid hsl(0deg 5% 86%);
                }
            }

            span {
                height: 100%;
            }
        }

    }

}
</style>